import { Button, Flex, FormLabel, HStack, Input, PinInput, PinInputField,Text,useColorModeValue } from "@chakra-ui/react";
import { Globle_app_context } from "../../context/globle_context";
import { useContext } from "react";

export default function OtpVerification(){
      const {
       setotp_verification,
       hendleOtp_verification,
       sign_up_state_loading
      } = useContext(Globle_app_context);
      const titleColor = useColorModeValue("teal.300", "teal.200");
      const textColor = useColorModeValue("gray.700", "white");
      const bgColor = useColorModeValue("white", "gray.700");
      const bgIcons = useColorModeValue("teal.200", "rgba(255, 255, 255, 0.5)");
    return (
      <Flex
        w="100%"
        className="h-[100vh]"
        alignItems="center"
        justifyContent="center"
      >
        <Flex
          alignItems="center"
          direction="column"
          w="445px"
          background="transparent"
          borderRadius="15px"
          p="40px"
          mx={{ base: '100px' }}
          bg={bgColor}
          boxShadow="0 20px 27px 0 rgb(0 0 0 / 5%)"
        >
          <Text
            fontSize="xl"
            className="text-[#51bcfa]"
            fontWeight="bold"
            textAlign="center"
            mb="22px"
          >
            OTP Verification
          </Text>

          <HStack>
            <PinInput onChange={(e) => setotp_verification(e)}>
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
              <PinInputField />
            </PinInput>
          </HStack>
          <br />
          <br />
          <Button
            isLoading={sign_up_state_loading}
            isDisabled={sign_up_state_loading}
            onClick={(e) => hendleOtp_verification(e)}
            bg="#a984b2"
            fontSize="10px"
            color="white"
            fontWeight="bold"
            w="100%"
            h="45"
            mb="24px"
            _hover={{
              bg: '#51bcfa',
            }}
            _active={{
              bg: '#51bcfa',
            }}
          >
            VERIFY
          </Button>
        </Flex>
      </Flex>
    );
}


